import {
  ChangeDetectionStrategy,
  Component,
  ComponentFactory,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

@Component({
    selector: 'app-toolbar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false
})
export class ToolbarComponent implements OnInit {
  public items!: ToolbarItem[];
  public extraComponentFactory!: ComponentFactory<any>;
  @Input() public vertical = false;

  public cssClass!: string;
  public dividerClass!: string;

  public isSetup: boolean = true;
  public isResult: boolean = true;
  public isVersions: boolean = true;

  @ViewChild('extraItemsContainer', { read: ViewContainerRef, static: true })
  private _extraItemsContainer!: ViewContainerRef;
  // @ViewChild('extraItemsContainer', { static: true }) _extraItemsContainer!: ElementRef;

  public constructor(elementRef: ElementRef) {
    const element: HTMLElement = elementRef.nativeElement;

    if (element.parentElement) {
      element.parentElement.setAttribute('style', 'background-color: #e0e0e0');
    }
  }

  public ngOnInit() {
    this.cssClass = this.vertical ? 'toolbar vertical' : 'toolbar';
    this.dividerClass = this.vertical ? 'horizontal-divider' : 'vertical-divider';

    if (this.extraComponentFactory) {
      this._extraItemsContainer.createComponent(this.extraComponentFactory);
    }
  }

  public execute(item: ToolbarItem) {
    if (item.execute) {
      item.execute();
    }
  }
}

export interface ToolbarItem {
  imageUrl?: string;
  tooltip?: string;
  getHidden?: () => boolean;
  getActive?: () => boolean;
  execute?: () => void;
  divider?: boolean;
}
